import { Navigate, Outlet, RouteObject, useLocation } from "react-router-dom";

import { PendingUserBanner } from "@/common/components/pending-user-banner/pending-user-banner";

const getAbsolutePath = (path: string) => `/${path}`;

const wrapWithPendingUserBanner = (routes: RouteObject[]) => [
  {
    children: routes,
    element: (
      <PendingUserBanner>
        <Outlet />
      </PendingUserBanner>
    ),
  },
];

const NavigateToInitialPage = ({ page }: { page: string }) => {
  const { pathname } = useLocation();

  if (pathname === "/") {
    return <Navigate replace to={getAbsolutePath(page)} />;
  }

  return null;
};

export { getAbsolutePath, NavigateToInitialPage, wrapWithPendingUserBanner };
